import { useEffect, useState } from "react";

import { CreateWipViewModel } from "../../viewmodels/wips/CreateWipViewModel";

import { connect } from "react-redux";

import * as actions from "../../store/actions/index";

import { withRouter } from "../../shared/utility";

import CreateWipForm from "../../components/forms/wips/CreateWipForm";
import EmptyModal from "../../components/modals/EmptyModal";
import SlideOver from "../../components/slideOver/SlideOver";
import { FormLoadingSkeleton } from "../../components/shared/ContentLoadingSkeleton";

function CreateWip(props) {
  const { addSnackbar, logout } = props;
  const [initialLoading, setInitialLoading] = useState(true);
  const {
    emptyModal,
    setEmptyModelOpen,
    roomOptions,
    getRoomOptionsForDropdown,
    isEdit,
    createWip,
    wip,
    onAddItemToWipByBarcode,
    getRemoveReasonsOptionsForDropdown,
    updateWip,
    openSlideForManufacturedItemDetails,
    setSlideOver,
    slideOver,
    onAskReturnIncomingItem,
    onAskDeleteWipOutputItem,
    showError,
  } = CreateWipViewModel(logout, addSnackbar);

  useEffect(() => {
    Promise.all([
      getRoomOptionsForDropdown(),
      getRemoveReasonsOptionsForDropdown(),
    ]).finally(() => setInitialLoading(false));
  }, []);

  return (
    <div>
      <div className="mt-2 px-4 sm:px-8">
        {initialLoading ? (
          <FormLoadingSkeleton />
        ) : (
          <CreateWipForm
          isEdit={isEdit}
          createWip={createWip}
          wip={wip}
          roomOptions={roomOptions}
          onAddItemToWipByBarcode={onAddItemToWipByBarcode}
          updateWip={updateWip}
          openSlideForManufacturedItemDetails={
            openSlideForManufacturedItemDetails
          }
          onAskReturnIncomingItem={onAskReturnIncomingItem}
          onAskDeleteWipOutputItem={onAskDeleteWipOutputItem}
          showError={showError}
          outgoing={{
            fetchOutgoingRowDetails: {},
            outgoingLoadingRows: [],
            outgoingRowDetails: [],
            fetchOutgoingSubRowDetails: {},
            outgoingSubRowDetails: [],
            outgoingSubLoadingRows: [],
            setOutgoingRowDetails: {},
            setOutgoingSubRowDetails: {},
          }}
          />
        )}
      </div>

      <EmptyModal
        childComponent={emptyModal.childComponent}
        open={emptyModal.open}
        setOpen={setEmptyModelOpen}
      />
      <SlideOver
        childComponent={slideOver.childComponent}
        slideOver={slideOver}
        setSlideOver={setSlideOver}
        customClass="max-w-3xl"
      />
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(actions.logout()),
    addSnackbar: (snackbar) => dispatch(actions.addSnackbar(snackbar)),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(CreateWip)
);
